<template>
  <div class="root">
    <modelframe :message="message">
      <my-table
          :data="tableData"
          :count="count"
          :limit="param.limit"
          @sizeChange="handlerSizeChange"
          :column-set="columnSet"
          @getPage="getPage"
          :type="tableType"
      />
    </modelframe>
  </div>
</template>

<script>
import MyTable from "@/components/myTable";
export default {
  name: "orderManage",
  components: {MyTable},
  data(){
    return {
      typePrice:[
        {columnName:'id',width:'180',label:'项目名',sortable:true},
        {columnName:'model_type',width:'180',label:'设备类型',labelType:'blue'},
        {columnName:'model_name',width:'180',label:'产品型号',labelType:'green'},
        {columnName:'quantity',width:'180',label:'数量',sortable:true},
        {columnName:'price_unit',width:'180',label:'单价',sortable:true},
        {columnName:'price_total',width:'180',label:'总价',sortable:true},
      ],
      typeDrawing:[
        {columnName:'id',width:'180',label:'订单号',sortable:true},
        {columnName:'modelType',width:'180',label:'产品类型',labelType:'blue'},
        {columnName:'modelName',width:'180',label:'产品型号',labelType:'green'},
        {columnName:'quantity',width:'180',label:'数量',sortable:true},
        {columnName:'createTime',width:'180',label:'提交日期',sortable:true},
        {columnName:'drawing',width:'180',label:'方案图',sortable:true},
      ],
      modelData:[],
      message:{
        code:0,
        msg:null
      },
      count:0,
      param:{
        limit:8,
        page:1,
        status:1,
      },
      openDialog:false
    }
  },
  methods:{
    handlerSizeChange(size){
      this.param.limit = size;
      this.getPage();
    },
    getPage(page){
      this.param.page = page??1;
      this.setMessage(1);//设置Loading
      this.$api.modelList(this.param.limit,this.param.page).then(data=>{
        if(data){
          this.tableData = data.order;
          this.count = data.count;
          this.setMessage(0);
        }else{
          this.setMessage(-1,data.msg);
        }
      }).catch(error=> this.setMessage(-1,'请求失败！错误信息：'+error));
    },
    setMessage(code,msg){
      this.message.code =code;
      this.message.msg =msg;
    },
  },
  computed:{
    columnSet(){
      return this.tableType==='price'?this.typePrice:this.typeDrawing;
    },
    tableData:{
      set(val){
        this.modelData= [];
        let row = this.tableType==='price'
            ?{id:'',model_type:'',model_name:'',quantity:'',price_unit:'',price_total:''}
            :{id:'',modelType:'',modelName:'',quantity:'',createTime:'',drawing:''};
          for (const item of val) {
            let newRow = {};
            for (const key of Object.keys(row)) {
              row[key] = item[key];
              newRow = {...row};
            }
            this.modelData.push(newRow);
          }
      },
      get(){
        //todo:按产品型号过滤模型数据
        return this.modelData;
      }
    },
    tableType(){
      return this.$route.query.type;
    }
  },
  watch:{
    tableType:{
      immediate:true,
      handler(){
        /*this.getPage(1);*/
      }
    }
  },

  created() {
    this.setMessage(1);//设置Loading
    this.getPage(1);

  }
}
</script>

<style scoped>

</style>
